<div class="help-container" [ngClass]="{'helping':help}">
    <div class="backdrop"></div>
    <div class="help-body">
        <div (click)="help = !help" class="help-triangle">
            <div *ngIf="!help">Brauchen Sie Hilfe? </div>
            <div *ngIf="help">schliessen<i class="fa-solid fa-circle-xmark"></i></div>
        </div>
        <div class="help-content div-container">
            <div class="page-title">Hilfe benötigt</div>
            <i class="fa-solid fa-circle-question"></i>
            <p>Im bedienten Modus fragen Sie bitte<br>das Verkaufspersonal um Hilfe.<br><br></p>
            <p>Im unbedienten Modus kontaktieren Sie uns<br>bitte telefonisch unter <b>058 433 55 77</b>.</p>
        </div>
    </div>
</div>